<template lang="pug">
b-container
  b-form-row.align-items-center.mt-3.mb-4
    b-col
      h4.mb-1 KPIs
      p.mb-0.text-secondary Aquí se muestran los indicadores clave de desempeño (KPIs) de tu bot. Para actualizar los datos que se muestran en las gráficas, cambia el rango de fechas.
  platforms-tabs.mb-3(:active='platform', @click:active='platform = $event')
  div(v-for='element in elements', :key='element')
    .d-flex.align-items-center.mb-3
      b-link.text-reset(v-b-toggle='`${element}_section`')
        h5.mb-0 {{ titles[element] }}
          chevron-down-icon.ml-1.icon-md
    b-collapse.mb-4(visible, :id='`${element}_section`')
      b-col.d-flex.justify-content-start.p-0.w-100.align-items-baseline
        b-col.p-0
          date-range-picker.mb-3(
            v-bind='calendar_props',
            v-model='dates[element]',
            :maxDate='$moment().format()',
            @update='changeDates(element)')
            template.w-100(v-slot:input='picker')
              b-input-group
                b-form-input.readonly-white(
                  placeholder='Seleccionar fecha...',
                  :value='parseDates(element)',
                  readonly)
                b-input-group-append
                  b-input-group-text
                    calendar-icon.text-secondary.icon-sm
        b-col(col='auto', v-if='showWhatsappAccounts(element)')
          b-input-group
            v-select.mt-2(
              placeholder='Seleccionar whatsapp...',
              :options='whatsappAccounts',
              label='name',
              style='min-width: 250px',
              :clearable='false',
              v-model='selectedWhatsapp')
        b-col.text-sm.text-secondary(cols='4', v-if='showWhatsappAccounts(element)')
          p *El registro de conversaciones y mensajes por linea se comenzó a realizar a partir del 2 de diciembre de 2022.
      div(v-if='element === "conversations"')
        b-row
          b-col(md='5')
            b-form-row.mb-1.justify-content-between.align-items-center(
              v-for='data in conversations.data',
              :key='data.name')
              b-col(cols='7')
                p.mb-0.text-secondary {{ data.title }}
              b-col(cols='auto')
                b-spinner(small, variant='info', v-if='conversations.loading')
                b(v-else) {{ data.value }}
            hr
            b-form-row.mb-1.justify-content-between.align-items-center(
              v-if='hasWhatsapp',
              v-for='[status, total] of waTemplatesData',
              :key='status')
              b-col(cols='7')
                p.mb-0.text-secondary Plantillas {{ translateWAStatus(status) }}
              b-col(cols='auto')
                b-spinner(small, variant='info', v-if='conversations.loading')
                b(v-else) {{ total }}
            b-col.mt-3.p-0
              b-button(
                variant='soft-primary',
                @click='usersAndBotReport',
                v-if='element === "conversations"',
                :disabled='downloading') Descargar reporte
              b-spinner.ml-2(small, variant='primary', v-if='downloading')
          b-col.d-flex.align-items-center.justify-content-center(md='7')
            b-overlay.w-100(
              :show='conversations.loading',
              variant='transparent',
              spinner-variant='primary')
              canvas#conversations_chart
      div(v-else-if='element === "answers"')
        b-row
          b-col(md='5')
            b-form-row.mb-1.justify-content-between.align-items-center(
              v-for='data in answers.data',
              :key='data.name')
              b-col(cols='7')
                p.mb-0.text-secondary {{ data.title }}
              b-col(cols='auto')
                b-spinner(small, variant='info', v-if='answers.loading')
                b(v-else) {{ data.value }}
          b-col.d-flex.align-items-center.justify-content-center(md='6')
            b-overlay.w-100(
              :show='answers.loading',
              variant='transparent',
              spinner-variant='primary')
              canvas#answers_chart
      div(v-else-if="element !== 'ecommerce'")
        b-overlay.w-100(:show="loading === element", variant="transparent", spinner-variant="primary")
          canvas(:id="`${element}_chart`")
</template>

<script>
import axios from 'axios'
import Chart from 'chart.js'
import 'chartjs-plugin-datalabels'
import Days from '../../data/days'
import Download from 'downloadjs'
import KolorWheel from 'kolorwheel'
import { mapActions, createNamespacedHelpers } from 'vuex'
import Months from '../../data/months'
import PlatformsTabs from '../../components/PlatformsTabs.vue'
import { VueFunnelGraph } from 'vue-funnel-graph-js'
import _ from 'lodash'

const platformController = createNamespacedHelpers('platform')
const templatesController = createNamespacedHelpers('message_template')
const API_URL = process.env.VUE_APP_KPIS_URL

export default {
  name: 'Kpis-view',
  data() {
    return {
      timezone: '',
      selectedWhatsapp: { name: 'Todos los whatsapp', modelId: 'all' },
      hsmData: { sent: 0, delivered: 0, read: 0 },
      downloading: false,
      loading: null,
      platform: 'all',
      delay: 9000,
      media_messages_conversation: 0,
      elements: [
        'conversations',
        'answers',
        'messages',
        'chats'
      ],
      calendar_props: {
        linkedCalendars: false,
        showDropdowns: true,
        ranges: false,
        opens: 'right',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        },
        parentEl: '#router-container'
      },
      dates: {
        conversations: {
          startDate: null,
          endDate: null
        },
        answers: {
          startDate: null,
          endDate: null
        },
        messages: {
          startDate: null,
          endDate: null
        },
        chats: {
          startDate: null,
          endDate: null
        },
        ecommerce: {
          startDate: null,
          endDate: null
        }
      },
      titles: {
        conversations: 'Datos de usuarios y conversaciones',
        answers: 'Nivel de respuesta',
        messages: 'Mensajes por hora',
        chats: 'Conversaciones por día',
        ecommerce: 'Datos de Ecommerce'
      },
      conversations: {
        loading: false,
        chart: null,
        time_out: null,
        data: [
          { name: 'conversations', title: 'Total de conversaciones', value: 0 },
          {
            name: 'outboundConversations',
            title: 'Conversaciones outbound',
            value: 0
          },
          {
            name: 'inboundConversations',
            title: 'Conversaciones inbound',
            value: 0
          },
          { name: 'uniqueUsers', title: 'Usuarios únicos', value: 0 },
          { name: 'totalMessages', title: 'Total de mensajes', value: 0 },
          { name: 'userMessages', title: 'Mensajes de usuarios', value: 0 },
          { name: 'botMessages', title: 'Mensajes del bot', value: 0 },
          {
            name: 'adminMessages',
            title: 'Mensajes del administrador',
            value: 0
          },
          {
            name: 'chatsWithUser',
            title: 'Conversaciones respondidas por usuarios',
            value: 0
          }
        ]
      },
      answers: {
        loading: false,
        chart: null,
        time_out: null,
        data: [
          {
            name: 'answer_messages',
            title: 'Mensajes respondidos',
            value: 0
          },
          {
            name: 'no_answer_messages',
            title: 'Mensajes no respondidos',
            value: 0
          }
        ]
      },
      messages: {
        loading: false,
        chart: null
      },
      chats: {
        loading: false,
        chart: null
      },
      ecommerce: {
        loading: false,
        chart: null,
        data: [
          {
            name: 'show_products',
            title: 'Ver productos',
            value: 0
          },
          {
            name: 'add_product',
            title: 'Agregar productos al carrito',
            value: 0
          },
          {
            name: 'show_cart',
            title: 'Ver carrito de compras',
            value: 0
          },
          {
            name: 'remove_product',
            title: 'Quitar producto del carrito',
            value: 0
          },
          {
            name: 'add_address',
            title: 'Agregar dirección de envío',
            value: 0
          }
        ]
      }
    }
  },
  computed: {
    ...templatesController.mapState({
      whatsappAccounts: (state) => {
        const whatsapps = state.whatsapp_accounts.map(
          ({ model_id: modelId, name, phone_number: phoneNumber }) => ({
            modelId,
            name: name || phoneNumber
          })
        )
        return [
          { name: 'Todos los whatsapp', modelId: 'all' },
          ...whatsapps
        ]
      }
    }),
    ...platformController.mapState({
      platforms: (state) => state.platforms
    }),
    ecommerce_data() {
      return {
        labels: this.ecommerce.data.map(({ title }) => title),
        values: this.ecommerce.data.map(({ value }) => value)
      }
    },
    hasWhatsapp() {
      const { platforms, platform } = this
      const hasWhatsapp = platforms.find((p) =>
        p.name.toLowerCase().includes('whatsapp')
      )
      const availableTabs = ['all', 'whatsapp']
      const canShowData = availableTabs.some((currentPlatform) =>
        platform.toLowerCase().includes(currentPlatform)
      )

      return hasWhatsapp && canShowData
    },
    waTemplatesData() {
      return Object.entries(this.hsmData)
    }
  },
  methods: {
    ...mapActions([
      'account/conversation_metrics',
      'account/get',
      'account/chat_activity',
      'account/messages_per_hour',
      'kpi/chart',
      'message_template/whatsapps'
    ]),
    getAccount() {
      this['account/get']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          const { resource = {} } = res
          const { timezone = 'America/Mexico_City' } = resource

          if (res.error) return this.$message.error(res.error)

          this.timezone = timezone || this.$moment.tz.guess()
        }
      })
    },
    translateWAStatus(status) {
      return (
        {
          sent: 'enviadas por WhatsApp',
          read: 'leídas',
          delivered: 'entregadas',
          failed: 'no enviadas',
          total: 'enviadas desde app.nerds.ai'
        }[status] || status
      )
    },
    getConversationMetrics(next, showLoader = false) {
      this.conversations.loading = showLoader

      clearTimeout(this.conversations.time_out)

      const params = {
        startDate: this.$moment(this.dates.conversations.startDate)
          .startOf('day')
          .format(),
        endDate: this.$moment(this.dates.conversations.endDate)
          .endOf('day')
          .format(),
        platform: this.platform,
        platformModel: this.selectedWhatsapp.modelId,
        timezone: this.timezone
      }
      this['account/conversation_metrics']({
        account_id: this.$route.params.account_id,
        params,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          const formatter = new Intl.NumberFormat('en-US')
          this.hsmData = {
            total: res.hsmMessages.total,
            sent: res.hsmMessages.sent,
            failed: res.hsmMessages.failed,
            delivered: res.hsmMessages.delivered,
            read: res.hsmMessages.read
          }
          this.conversations.data.forEach(param => {
            param.value = res[param.name] ? formatter.format(res[param.name]) : 0
          })
          this.conversations.loading = false

          next(res)
        }
      })
    },
    urlToReport(params) {
      let url = `${API_URL}/api/v1/kpis/${this.$route.params.account_id}/download?`

      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          url += `&${key}=${value}`
        })
      }

      return url
    },
    async usersAndBotReport() {
      try {
        const year = this.$moment(this.dates.conversations.startDate)
          .startOf('day')
          .format()
          .split('-')[0]
        const url = this.urlToReport({ year })
        this.$message.info('Generando reporte...')
        this.downloading = true
        const res = await axios.get(url, { responseType: 'blob' })

        if (res.status === 202) {
          this.$message.info(
            'El reporte será enviado a su correo electrónico en unos minutos'
          )
          this.downloading = false
          return
        }
        if (res.error) {
          return this.$message.error('Ocurrió un error descargando el reporte')
        }
        Download(
          res.data,
          `reporte_conversaciones_${year}.csv`,
          res.headers['content-type']
        )
        this.$message.success('Reporte generado')
        this.downloading = false
      } catch (error) {
        this.$message.error('Ocurrió un error descargando el reporte')
        this.downloading = false
        console.error(error.message)
      }
    },
    createConversationChart(resource) {
      const conversations = this.conversations.data.map((d) => resource[d.name])

      this.conversations.chart = this.createChart({
        ctx: document.getElementById('conversations_chart').getContext('2d'),
        type: 'horizontalBar',
        labels: this.conversations.data.map((c) => c.title),
        datasets: [
          {
            data: conversations,
            backgroundColor: this.conversations.data.map((el, i) => {
              const color = new KolorWheel([65 * i, 80, 75])
              return color.getHex()
            }),
            borderWidth: 1
          }
        ],
        options: {
          cornerRadius: 5,
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 12,
                  minor: {
                    stepSize: 1,
                    autoSkip: false
                  }
                }
              }
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 10,
                  minor: {
                    stepSize: 1,
                    autoSkip: false
                  }
                }
              }
            ]
          },
          plugins: {
            datalabels: {
              color: '#404040',
              font: { size: 15 },
              formatter: function (value, ctx) {
                const maxValue = Math.max(...ctx.dataset.data)
                const tenPercents = Math.round(maxValue * 0.1)
                return value <= tenPercents ? '' : value
              }
            }
          }
        }
      })
    },
    updateConversationChart(resource) {
      const self = this

      this.conversations.chart.data.datasets.forEach((dataset) => {
        dataset.data = self.conversations.data.map(({ name }) => resource[name])
      })
      this.conversations.chart.update({ duration: 200 })
    },
    getAnswersMetrics(next, showLoader = false) {
      const self = this
      this.answers.loading = showLoader
      clearTimeout(this.answers.time_out)

      const params = {
        startDate: this.$moment(this.dates.answers.startDate)
          .startOf('day')
          .format(),
        endDate: this.$moment(this.dates.answers.endDate).endOf('day').format(),
        platform: this.platform,
        noAnswers: true
      }
      this['account/conversation_metrics']({
        account_id: self.$route.params.account_id,
        params,
        callback: (res) => {
          if (res.error) return self.$message.error(res.error)
          const formatter = new Intl.NumberFormat('en', {
            notation: 'compact'
          })
          const {
            botMessages = 0,
            noAnswerMessages = 0,
            adminMessages = 0,
            userMessages = 0
          } = res
          const total = botMessages + noAnswerMessages + adminMessages
          const answerMessages = total - noAnswerMessages
          const percentageAnswer =
            Math.round((answerMessages / total) * 100) || 0
          const percentageNoAnswer =
            Math.round((noAnswerMessages / total) * 100) || 0
          let result
          self.answers.data.forEach((d) => {
            switch (d.name) {
              case 'bot_messages':
                d.value = formatter.format(botMessages)
                break
              case 'answer_messages':
                result = userMessages ? (((userMessages - noAnswerMessages) / userMessages) * 100) : 0
                d.value = `${userMessages - noAnswerMessages}: ${result.toFixed(2)}%`

                break
              case 'no_answer_messages':
                result = userMessages ? ((noAnswerMessages / userMessages) * 100) : 0
                d.value = `${noAnswerMessages}: ${result.toFixed(2)}%`

                break
            }
          })
          self.answers.loading = false
          next({ answerMessages, noAnswerMessages })
        }
      })
    },
    createAnswersChart({ answerMessages = 0, noAnswerMessages = 0 }) {
      this.answers.chart = this.createChart({
        ctx: document.getElementById('answers_chart').getContext('2d'),
        type: 'pie',
        labels: ['Respondidos', 'No respondidos'],
        datasets: [
          {
            data: [answerMessages, noAnswerMessages],
            backgroundColor: ['#EAF28C', '#8CD9F2'],
            borderWidth: 1
          }
        ],
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            datalabels: {
              color: '#404040',
              font: { size: 25 },
              formatter: function (value, ctx) {
                const formatter = new Intl.NumberFormat('en', {
                  notation: 'compact'
                })
                return formatter.format(value)
              }
            }
          }
        }
      })
    },
    updateAnswersChart({ answerMessages = 0, noAnswerMessages = 0 }) {
      this.answers.chart.data.datasets.forEach((dataset) => {
        dataset.data = [answerMessages, noAnswerMessages]
      })
      this.answers.chart.update({ duration: 200 })
    },
    getEcommerceMetrics() {
      const self = this
      this.ecommerce.loading = true

      const params = {
        date_from: this.$moment(this.dates.ecommerce.startDate)
          .startOf('day')
          .format(),
        date_to: this.$moment(this.dates.ecommerce.endDate)
          .endOf('day')
          .format(),
        platform: this.platform
      }

      this['account/chat_activity']({
        account_id: self.$route.params.account_id,
        params,
        callback: (res) => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            const { resources } = res
            for (const { action, total_action: totalAction } of resources) {
              const name = this.ecommerce.data.find((d) => d.name === action)
              if (name) {
                name.value = parseInt(totalAction)
              }
            }
            this.ecommerce.data = this.ecommerce.data.sort(
              (a, b) => b.value - a.value
            )
            self.ecommerce.loading = false
          }
        }
      })
    },
    getMessages(next, showLoader = false) {
      this.loading = showLoader

      const params = {
        init_date: this.$moment(this.dates.messages.startDate).format(),
        final_date: this.$moment(this.dates.messages.endDate).format(),
        platform: this.platform
      }

      this['account/messages_per_hour']({
        account_id: this.$route.params.account_id,
        params,
        callback: (res) => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          next(res.resource)
        }
      })
    },
    createMessagesChart(resource) {
      this.messages.chart = this.createChart({
        ctx: document.getElementById('messages_chart').getContext('2d'),
        type: 'bar',
        labels: resource.map((el) => `${el.hour} hrs.`),
        datasets: [
          {
            data: resource.map((el) => el.total),
            backgroundColor: resource.map((el, i, a) => {
              const aux = (50 / a.length) * el.place
              const color = new KolorWheel([210, 100, 50 + aux])
              return color.getHex()
            }),
            borderWidth: 1
          }
        ],
        options: {
          cornerRadius: 5,
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 12,
                  minor: {
                    stepSize: 1,
                    autoSkip: false
                  }
                }
              }
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 10,
                  minor: {
                    stepSize: 1,
                    autoSkip: false
                  }
                }
              }
            ]
          },
          plugins: {
            datalabels: {
              color: '#404040',
              font: { size: 18 },
              ...this.labelsConfig(
                resource,
                resource.map((el) => el.total)
              )
            }
          }
        }
      })
    },
    updateMessagesChart(resource) {
      this.messages.chart.destroy()
      this.createMessagesChart(resource)
    },
    getChats(next, showLoader = false) {
      const self = this
      this.loading = showLoader

      this['kpi/chart']({
        account_id: this.$route.params.account_id,
        date_from: this.$moment(this.dates.chats.startDate).format(),
        date_to: this.$moment(this.dates.chats.endDate).format(),
        platform: this.platform,
        graph: 'Conversations',
        filter: 'day',
        timezone: this.timezone,
        callback: (res) => {
          self.loading = false

          if (res.error) return self.$message.error(res.error)

          self.messages.loading = false
          next(res.resource)
        }
      })
    },
    createChatsChart(resource) {
      this.chats.chart = this.createChart({
        ctx: document.getElementById('chats_chart').getContext('2d'),
        type: 'bar',
        labels: resource.labels,
        datasets: resource.datasets.map((el) => {
          el.backgroundColor = el.data.map((el, i, a) => {
            const aux = (50 / a.length) * i
            const color = new KolorWheel([210, 100, 50 + aux])
            return color.getHex()
          })
          el.borderWidth = 1
          return el
        }),
        options: {
          cornerRadius: 5,
          responsive: true,
          maintainAspectRatio: true,
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 12,
                  minor: {
                    stepSize: 1,
                    autoSkip: false
                  }
                }
              }
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  autoSkip: false,
                  beginAtZero: true,
                  fontSize: 10,
                  minor: {
                    stepSize: 1,
                    autoSkip: false
                  }
                }
              }
            ]
          },
          plugins: {
            datalabels: {
              color: '#404040',
              font: { size: 18 },
              ...this.labelsConfig(
                resource,
                resource.datasets.map((e) => e.data)
              )
            }
          }
        }
      })
    },
    labelsConfig(resource, values) {
      return {
        formatter: function (value) {
          const dataSize = _.isArray(resource)
            ? resource.length
            : resource.labels.length
          const maxValue = Math.max(...values)
          const tenPercents = Math.round(maxValue * 0.1)
          if (dataSize > 20) return ''
          if (dataSize >= 10) return value < tenPercents ? '' : value
          return value
        },
        anchor: 'end',
        clamp: true,
        align: 'start'
      }
    },
    updateUsersChart(resource) {
      this.chats.chart.destroy()
      this.createChatsChart(resource)
    },
    createChart({ ctx, type, labels, datasets, options }) {
      return new Chart(ctx, {
        type,
        data: {
          labels,
          datasets
        },
        options
      })
    },
    parseDates(element) {
      const { startDate, endDate } = this.dates[element]
      return (
        this.$moment(startDate).format('DD MMM YYYY') +
        ' - ' +
        this.$moment(endDate).format('DD MMM YYYY')
      )
    },
    changeDates(chart) {
      switch (chart) {
        case 'conversations':
          this.getConversationMetrics(this.updateConversationChart, true)
          break
        case 'answers':
          this.getAnswersMetrics(this.updateAnswersChart, true)
          break
        case 'ecommerce':
          this.ecommerce.data.forEach((d) => {
            d.value = 0
          })
          this.getEcommerceMetrics()
          break
        case 'messages':
          this.getMessages(this.updateMessagesChart, chart)
          break
        case 'chats':
          this.getChats(this.updateUsersChart, chart)
          break
      }
    },
    getWhatsappAccounts() {
      const hasWhatsapp = this.platforms
        .map(({ title }) => title)
        .some((title) => title.toLowerCase().includes('whatsapp'))
      if (!hasWhatsapp) return
      this['message_template/whatsapps']({
        account_id: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) {
            this.$message.error('Error al obtener lineas de Whatsapp')
          }
          console.log(this.whatsappAccounts)
        }
      })
    },
    showWhatsappAccounts(element) {
      const isConversationSection = element === 'conversations'
      const isWhatsapp = this.platform.toLowerCase().includes('whatsapp')
      const hasMultipleWhatsappAccounts = this.whatsappAccounts.length > 2
      return isConversationSection && isWhatsapp && hasMultipleWhatsappAccounts
    },
    createAllCharts(chartFunc, ...args) {
      this.$nextTick(() => {
        chartFunc(...args)
      })
    }
  },
  mounted() {
    this.getAccount()
    this.getWhatsappAccounts()

    const elements = [
      'conversations',
      'answers',
      'ecommerce',
      'messages',
      'chats'
    ]

    for (const element of elements) {
      this.dates[element].startDate = this.$moment().subtract(7, 'days').format()
      this.dates[element].endDate = this.$moment().format()
    }

    const chartFuncs = [
      [this.getConversationMetrics, this.createConversationChart, true],
      [this.getAnswersMetrics, this.createAnswersChart, true],
      [this.getEcommerceMetrics],
      [this.getMessages, this.createMessagesChart, 'messages'],
      [this.getChats, this.createChatsChart, 'chats']
    ]

    for (const [chartFunc, ...args] of chartFuncs) {
      this.createAllCharts(chartFunc, ...args)
    }
  },
  watch: {
    selectedWhatsapp() {
      this.getConversationMetrics(this.updateConversationChart, true)
    },
    platform(value) {
      if (value) {
        this.getConversationMetrics(this.updateConversationChart, true)
        this.getAnswersMetrics(this.updateAnswersChart, true)
        this.getMessages(this.updateMessagesChart, 'messages')
        this.getChats(this.createChatsChart, 'chats')
        this.getEcommerceMetrics()
      }
    }
  },
  components: { PlatformsTabs }
}
</script>

<style lang="scss">
.big {
  width: 3rem;
  height: 3rem;
}

.label__value {
  color: rgba(0, 0, 0, 0.5) !important;
  font-weight: bold;
}

.label__title {
  font-size: 15px !important;
}
</style>
